module.exports = __webpack_public_path__ + "static/icons_startseite_jobs-4787c1ca23be3fc6181f68e8ce5c0212.png";